import { gql, TypedDocumentNode } from "@apollo/client";

import { Repo, MutationRepoCreateArgs } from "types/generated";

import { SPACELIFT_VCS_REPO_BASIC_FRAGMENT } from "../gql";

export const CREATE_SPACELIFT_VCS_REPO: TypedDocumentNode<
  { repoCreate: Repo },
  MutationRepoCreateArgs
> = gql`
  mutation CreateSpaceliftVcsRepo($input: RepoCreateInput!) {
    repoCreate(input: $input) {
      ...SpaceliftVcsRepoBasic
    }
  }
  ${SPACELIFT_VCS_REPO_BASIC_FRAGMENT}
`;
